import type { MapControlsSlice, GeoDataStateCreator } from './types';

export const createMapControlsSlice: GeoDataStateCreator<MapControlsSlice> = (set) => ({
  // Stato iniziale per i controlli base
  isFullscreenControlActive: false,
  isGeolocateControlActive: false,
  isNavigationControlActive: true,
  isScaleControlActive: false,
  isGlobeControlActive: false,
  isDrawWidgetActive: false, // Nuovo stato per il widget di disegno
  isTimeWidgetActive: false, // Nuovo stato per il widget Orologio

  // Azioni per i controlli base
  toggleFullscreenControl: () =>
    set((state) => ({ isFullscreenControlActive: !state.isFullscreenControlActive })),
  toggleGeolocateControl: () =>
    set((state) => ({ isGeolocateControlActive: !state.isGeolocateControlActive })),
  toggleNavigationControl: () => // Manteniamo l'azione anche se non usata nell'UI
    set((state) => ({ isNavigationControlActive: !state.isNavigationControlActive })),
  toggleScaleControl: () =>
    set((state) => ({ isScaleControlActive: !state.isScaleControlActive })),
  toggleGlobeControl: () =>
    set((state) => ({ isGlobeControlActive: !state.isGlobeControlActive })),
  toggleDrawWidget: () => // Nuova azione per il widget di disegno
    set((state) => ({ isDrawWidgetActive: !state.isDrawWidgetActive })),
  toggleTimeWidget: () => // Nuova azione per il widget Orologio
    set((state) => ({ isTimeWidgetActive: !state.isTimeWidgetActive })),
});